'use es6';

import { Loadable } from 'foundations-components/transitional/utils/Loadable';
const loader = () => import( /* webpackChunkName: "delete-non-report-widget-dialog" */'./DeleteNonReportWidgetModal');
export default Loadable({
  loader,
  LoadingComponent: () => null
});